import React, {Component} from 'react';
import IconBoxes from '../../components/iconBoxes.js';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import BootstrapTable from '../../components/tables/bootstrapTable.js';

import IncomeDiscount from '../../charts/incomeDiscount' ;
import IncomeDiscountTable from '../../components/tables/incomeDiscountsTable'
import RestricteDAccounts from '../../charts/restrictedAccounts';
import RestrictedAccountsTable from '../../components/tables/restrictedAccountsTable'
import MonthlyRecovery from '../../charts/monthlyRecovery';
import AnnualIncome from '../../charts/annualIncome';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';

class PlaceClient extends Component {


  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }

  render() {
    var result;

    if (this.state.userData.rol === ROL.CLIENT.url) {
      result = <div>
        <SidebarMenuRouters profile="/profile-client/place/" place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name}/>
        <div className="grid-data-dash">
          <IconBoxes bu={this.props.match.params.vp}/>
          <div className="row">
            <div className="col-sm-6">
              <Panel title="Recuperación mensual de adeudos (mdp)" righticon={false}>
                <MonthlyRecovery bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Ingreso anual, año actual vs año anterior (mdp)" righticon={false}>
                <AnnualIncome bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Ingresos contra descuentos" righticon={false}>
                <IncomeDiscount bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Ingresos contra descuentos" righticon={false}>
                <IncomeDiscountTable bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Cuentas restringidas" righticon={false}>
                <RestricteDAccounts bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Cuentas restringidas" righticon={false}>
                <RestrictedAccountsTable bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Recuperación mensual" righticon={false}>
                <BootstrapTable striped={true} bu={this.props.match.params.vp}/>
              </Panel>
            </div>
          </div>
        </div>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default PlaceClient;



// WEBPACK FOOTER //
// ./src/scene/client/placeClient.js